var _ellipse, _path, _ellipse2, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStep4 = function SvgStep4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12.5714,
    rx: 12,
    ry: 11.4286,
    fill: "#0A446D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1746 16.3536C8.1746 16.1296 8.2866 16.0176 8.5106 16.0176H10.6778V8.8104L9.233 10.1712C9.1546 10.2496 9.0762 10.2888 8.9978 10.2888C8.9194 10.2888 8.8578 10.2552 8.813 10.188L7.9058 9.0288C7.8386 8.9504 7.805 8.8776 7.805 8.8104C7.805 8.732 7.8498 8.6536 7.9394 8.5752L10.2914 6.4584C10.381 6.38 10.4594 6.324 10.5266 6.2904C10.5938 6.2568 10.7058 6.24 10.8626 6.24H12.5258C12.7498 6.24 12.8618 6.352 12.8618 6.576V16.0176H15.029C15.253 16.0176 15.365 16.1296 15.365 16.3536V17.664C15.365 17.888 15.253 18 15.029 18H8.5106C8.2866 18 8.1746 17.888 8.1746 17.664V16.3536Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12.5714,
    rx: 12,
    ry: 11.4286,
    fill: "#0A446D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6216 14.2032C8.6216 14.0464 8.6328 13.9288 8.6552 13.8504C8.6888 13.772 8.728 13.688 8.7728 13.5984L12.452 6.576C12.5192 6.4416 12.592 6.352 12.6704 6.3072C12.76 6.2624 12.8664 6.24 12.9896 6.24H14.6696C14.8376 6.24 14.9216 6.3016 14.9216 6.4248C14.9216 6.4696 14.9048 6.5256 14.8712 6.5928L11.024 13.8504H13.46V10.44C13.46 10.216 13.572 10.104 13.796 10.104H15.308C15.532 10.104 15.644 10.216 15.644 10.44V13.8504H17.2232C17.4472 13.8504 17.5592 13.9624 17.5592 14.1864V15.564C17.5592 15.788 17.4472 15.9 17.2232 15.9H15.644V17.664C15.644 17.888 15.532 18 15.308 18H13.796C13.572 18 13.46 17.888 13.46 17.664V15.9H8.9576C8.7336 15.9 8.6216 15.788 8.6216 15.564V14.2032Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStep4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/step4.a3e537ad.svg";
export { ForwardRef as ReactComponent };